import { useQuery } from '@tanstack/react-query';
import { AffiliateProgramService } from '@/services/affiliate-program.service';
import { AffiliateProgramResponse } from '@/services/affiliate-program.service';
import { useTranslation } from 'react-i18next';

export const useFetchAffiliateProgram = (productId: string) => {
  const {
    data: affiliateProgram,
    isPending: isLoading,
    refetch,
    isRefetching,
    error,
  } = useQuery<AffiliateProgramResponse>({
    queryKey: ['affiliate-program', productId],
    queryFn: async () => await AffiliateProgramService.getAffiliateProgram(productId),
  });

  const { t } = useTranslation('affiliates')

  return {
    affiliateProgram,
    isLoading,
    refetch,
    isRefetching,
    error: error
      ? (error as Error).message || t('fetch_affiliate_program_error')
      : null,
  };
};